import React from "react";
import "./About.scss";

const About = () => {
  return (
    <div className="About">
      <h1>About Us</h1>
      <p>
        Looking for a drink recipe? Search our database to find any cocktail you
        want to make! We give you the ingredients, glass-type, and instructions!
      </p>
    </div>
  );
};

export default About;
